import React, { useState } from "react";
import All_Buyer_Edit from "./Product_Owner_Edit_Form_SubCom_Table/All_Buyer_Edit/All_Buyer_Edit";
import All_Seller_Edit from "./Product_Owner_Edit_Form_SubCom_Table/All_Seller_Edit/All_seller_Edit";

function Product_Owner_Edit_Form() {
  const [activeTab, setActiveTab] = useState("All_Buyer");
  return (
    <div>
      <div className="flex flex-col">
        {/* Tab Navigation */}
        <div className="flex items-center justify-between text-lg font-semibold gap-4 mt-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setActiveTab("All_Buyer")}
              className={
                activeTab === "All_Buyer"
                  ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                  : "text-gray-500 hover:text-[#FF0000]"
              }
            >
              All Buyer
            </button>
            <button
              onClick={() => setActiveTab("All_Seller")}
              className={
                activeTab === "All_Seller"
                  ? "text-[#FF0000] font-semibold underline decoration-[#FF0000] underline-offset-4"
                  : "text-gray-500 hover:text-[#FF0000]"
              }
            >
              All Seller
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="mt-6 ">
          {activeTab === "All_Buyer" && <All_Buyer_Edit />}
          {activeTab === "All_Seller" && <All_Seller_Edit/>}
        </div>
      </div>
    </div>
  );
}

export default Product_Owner_Edit_Form;
